'use client'

import { Toaster } from '@/components/ui/sonner'

export default function ToasterProvider() {
  return (
    <Toaster
      position='top-right'
      richColors
      theme='dark'
      closeButton
      toastOptions={{ className: 'w-full' }}
      className='![--width:400px]'
    />
  )
}
